<template>
  <select
    :class="handleModifierClass"
    @change="changed = true"
  >
    <slot />
  </select>
</template>

<script>
export default {
  data() {
    return {
      changed: false,
      baseClass: undefined,
    }
  },
  computed: {
    handleModifierClass() {
      return { [`${this.baseClass}--changed`]: this.changed }
    },
  },
  mounted() {
    ;[this.baseClass] = this.$el.classList
  },
}
</script>
